import metrics from "@arkadium/jarvis/dist/metrics";
import { LIB_VERSION } from "../version";

const BASE_CONFIG = {
  dsn: "https://84b97741723b7c6c516273484f949bd0@sentry.arkadiumhosted.com/53",
  projectId: "53",
  sdkName: "ads.video.metrics",
  transactionName: "ads.video.load",
  version: LIB_VERSION,
  renderTimeoutMs: 35000,
};

metrics.configure(BASE_CONFIG);

export default metrics;
